<template>
  <Modal
    actions
    :name="modalName"
    :title="$t('appointment.label.deleteSelectedFiles')"
  >
    <template v-slot:body>
      <h3 class="red--text">
        {{ $t('upload.delete.title') }}
      </h3>
      <p>
        {{
          $t('upload.delete.deleteSelected', {
            value: files.length,
          })
        }}
      </p>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal"
        :disabled="isLoading"
        elevation="0"
        color="grey darken-1"
        text
      >
        {{ $t('deleteModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="handleDelete"
        :loading="isLoading"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('deleteModal.buttons.deleteSelectedFiles') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAppointmentDeleteSelectedFiles',

  props: {
    handleDelete: {
      type: Function,
      required: false,
    },
    files: {
      type: Array,
      required: true
    },
    modalName: {
      type: String,
      required: true,
    }
  },

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    ...mapMutations(['closeAllModals']),

    closeModal() {
      this.closeAllModals()
    },
  },
}
</script>
